import debounce from 'lodash/debounce'
import {
  loadJsonApiEntities,
  loadUpdatedJsonApiEntities,
} from '../actions/loadJsonApiEntities'

const UPDATE_TIMER = 1250

class UpdateQueue {
  constructor(ensureNewer = true) {
    this.initializeQueue()

    this.debouncedUpdateRedux = debounce(() => {
      this.updateRedux(ensureNewer)
    }, UPDATE_TIMER)
  }

  initializeQueue() {
    this.queueData = {}
    this.queueData.payload = {}
    this.queueData.payload.data = []
    this.queueData.payload.included = []
    this.queueData.payload.meta = []
  }

  addItem(entity) {
    this.queueData.payload.data.push(entity.data)

    if (entity.included) {
      entity.included.map((included) =>
        this.queueData.payload.included.push(included)
      )
    }

    if (entity.meta) {
      entity.meta.map((meta) => this.queueData.payload.meta.push(meta))
    }
    this.debouncedUpdateRedux()
  }

  updateRedux(ensureNewer) {
    if (ensureNewer) {
      window.dispatch(loadUpdatedJsonApiEntities(this.queueData.payload))
    } else {
      window.dispatch(loadJsonApiEntities(this.queueData.payload))
    }
    this.initializeQueue()
  }
}

// this exports a singleton object so that there is only ever one queue.
export const ReduxOverwriteQueue = new UpdateQueue(false)
export const ReduxUpdateQueue = new UpdateQueue(true)
